export const fhbLangEs = {
    ticketFhb: {
        usePage: "Página de uso",
        verifyDistribution: "Asignación de validación telefónica",
        urgeDistribution: "Asignación de Urge",
        staffMaxDailyWorkingNumber: "número máximo de casos terminados del día",
        ticketMaxWorkingNumber: "número máximo de casos asignados del día",
        ticketPartialCompletedWorkloadFactor: "porcentaje de los casos incompletos ",
        phoneVerifyDistribution: "Asignación de validación telefónica",
        distributionManagement: "Administración de asignación",
        ticketID: "Ticket ID",
        verifyCompleteTime: "Tiempo de Finalización",
        ticketHandle: "Casos operados",
        ticketList: "Lista de casos",
        waitingProcess: "Casos pendientes",
        partialCompleted: "Parcial completo",
        phoneVerify: "Validación telefónica",
        stopAcceptTicket: "Detener el trabajo",
        continueAcceptTicket: "Empezar el trabajo",
        qualityInspectionResults: "Resultado de validación",
        auditResults: "Resultado de validación",
        creditReviewResults: "Resultado de validación",
        auditType: "Tipo de validacón",
        createTime: "Tiempo de creación",
        TicketCategory: "Clasificaciòn de reserva",
        IndividualDeductibleAmount: "monto límite de descuento",
        GroupDeductibleAmount: "monto límite para descuento del equipo"
    },
    menuFhb: {
        creditApprovalTicketHandle: "Información de validación",
        auditStaffManagement: "Administración de casos",
        ticketHandle: "procesamiento de órdenes de trabajo",
        qualityInspectionTicketHandle: "Operar los casos ",
        workOrderProcessingList: "Lista de casos procesados",
    },
    robotFhb: {
        taskManagement: "Administracion de tareas",
        robotService: "Servicio de robot",
        robot: "Robot",
        employeeType: "Tipo de empleados",
        remainingToBeRepaidAmount: "Monto restante a pagar",
        taskName: "Nombre de tarea",
        stratetyName: "Mombre de estrategia",
        startTime: "Tiempo inicial",
        Time: "Tiempo inicial - Hora de finalización",
        operator: "Operador",
        executionTime:"Tiempo de ejecución",
        timeSlot: "Período",
        morning: "Por la mañana",
        afternoon: "Por la tarde",
        details: "Detalles",
        DistinguishingMode: "Modo de distinción"
    },
    messageFhb: {
        selectLanguage: "seleccione idioma"
    }
};